import React from 'react'
import BluePlaneProps from './BluePlaneProps'
import BluePlaneImg from 'assets/images/Benzema-club/blue-plane.png';

const BluePlane: React.FC<BluePlaneProps> = ({ height, width }) => {
    return <img style={{ width: width ?? "32px", height: height ?? "32px" }} src={BluePlaneImg} />
}

export default BluePlane;
